import React, { Component } from 'react';

export default class InputSwitch extends Component {
	render() {
		const { className, children, content, offContent, ...props } = this.props;
		return (
			<label className={`input-toggle ${offContent ? 'double-active' : ''} ${className ? className : ''}`}>
				{offContent &&
				<p className={`alternative ${props.checked ? 'deselected' : ''}`}>{offContent}</p>
				}
				<input
					type='checkbox'
					{...props}
				/>
				<span />
				<span className={props.checked ? '' : 'deselected'}>{content || children}</span>
			</label>
		);
	}
}